// Sample card from Airbnb
import React from "react";
import { Link } from "react-router-dom"
import { useNavigate } from "react-router-dom";
import swal from 'sweetalert';
import { useState } from 'react';
import { useParams } from "react-router-dom";
import Form from "react-validation/build/form";
import { Alert } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import APIConfig from "../../../api/APIConfig";

import {
    Box,
    Center,
    Heading,
    Button,
    Stack,
    Text,
    VStack,
    HStack,
    useColorModeValue,
    FormControl,
    FormLabel,
    Input,
    Select,
    Textarea,
} from '@chakra-ui/react';


function FormProposal() {
    const navigate = useNavigate();
    const [bayar, setBayar] = useState('');
    const [namaProposal, setnamaProposal] = useState('');
    const [tanggalMulai, setTanggalMulai] = useState(new Date());
    const [tanggalSelesai, setTanggalSelesai] = useState(new Date());
    const [batasWaktuPembayaran, setBatasWaktuPembayaran] = useState(new Date());
    const [lokasi, setLokasi] = useState('');
    const [deskripsiAktivitas, setDeskripsiAktivitas] = useState('');
    const [namaPosisi, setNamaPosisi] = useState('');
    const [deskripsiPekerjaan, setDeskripsiPekerjaan] = useState('');
    const [kriteriaPeserta, setKriteriaPeserta] = useState('');
    const [kemampuanWajib, setKemampuanWajib] = useState('');
    const [infoTambahan, setInfoTambahan] = useState('');
    const [nominal, setNominal] = useState();
    const [kuota, setKuota] = useState();
    const [validation, setValidation] = useState({});
    const { id } = useParams();

    const submitProposal = async (e) => {
        e.preventDefault();
        swal("Apakah Anda yakin ingin menambahkan proposal?", {
            buttons: {
                yes: {
                text: "Ya",
                value: "yes"
                },
                no: {
                text: "Kembali",
                value: "no"
                }
        }
        }).then((value) => {
            if (value === "yes") {
                APIConfig.post(`v1/proposal/${id}`, {
                    namaProposal: namaProposal,
                    tanggalMulai: tanggalMulai,
                    tanggalSelesai: tanggalSelesai,
                    batasWaktuPembayaran : batasWaktuPembayaran,
                    lokasi: lokasi,
                    deskripsiAktivitas: deskripsiAktivitas,
                    namaPosisi: namaPosisi,
                    deskripsiPekerjaan: deskripsiPekerjaan,
                    kriteriaPeserta: kriteriaPeserta,
                    kemampuanWajib : kemampuanWajib,
                    nominal: nominal,
                    infoTambahan: infoTambahan,
                    kuota : kuota,
                })
                .then(() => {
                    console.log("berhasil") 
                    navigate(`/mitra/profile/proposal`);
                    swal({
                        title: "Kamu berhasil menambahkan proposal!",
                        icon: "success",
                        button: "OK",
                      });
        
                })
                .catch((error) => {
                    console.log(error);
                    setValidation(error.response.data);
                })
            }
            return false;
        });
    };


    return (
        <Center py={6}>
        <VStack align='stretch' justifyItems='left' fontFamily={'Inter'}>
            <Text
                pt={10}
                color={'gray.700'}
                fontWeight={600}
                fontSize={'2xl'}
                fontFamily={'Inter'}>
                Form Pengajuan Proposal
            </Text>
            <HStack color={'gray.500'} pb={10}>
                <Link to="/mitra/profile/proposal"> Daftar Proposal </Link>
                <p> / </p>
                <Link to="/mitra/profile/proposal/form"> Form Proposal</Link>
            </HStack>
            <Box
                m='10px'
                w='4xl'
                h="100%"
                border='1px'
                borderColor='gray.200'
                justifyContent='left'
                bg={useColorModeValue('white', 'gray.900')}
                rounded={'2xl'}
                p={6}
                overflow={'hidden'}>
                <VStack 
                spacing={4}
                align='stretch'
                p={3}
                >
                    <Heading
                        mb={6}
                        mt={3}
                        color={useColorModeValue('gray.700', 'white')}
                        fontSize={'xl'}
                        fontFamily={'Inter'}>
                        Aktivitas
                    </Heading>
                    
                    {
                        validation.errors &&
                            <Alert variant="danger">
                                <ul class="mt-0 mb-0">
                                    { validation.errors.map((error, index) => (
                                        <li key={index}>{ `${error.param} : ${error.msg}` }</li>
                                    )) }
                                </ul>
                            </Alert>
                    }
                    
                    <Form p={6} onSubmit={submitProposal}>

                        <FormControl pb={6} isRequired fontFamily={'Inter'} >
                        <FormLabel htmlFor='namaProposal'>Nama Proposal</FormLabel>
                        <Input 
                            id='namaProposal' 
                            placeholder='Masukkan nama proposal'
                            value={namaProposal}
                            onChange={(e) => setnamaProposal(e.target.value)}
                            />
                        </FormControl>
                        
                        <FormControl pb={6} isRequired fontFamily={'Inter'}>
                        <FormLabel htmlFor='tanggalMulai'>Tanggal Mulai</FormLabel>
                        <div>
                            <style>
                                {`.date-picker input {
                                    width: 100%;
                                    height: 40px;
                                    padding-left: 17px;
                                    border: 1px solid #E2E8F0;
                                    border-radius: 5px;}
                                .date-picker focus {
                                    border-color:#cd3232;
                                }
                                `}
                            </style>
                            <DatePicker wrapperClassName="date-picker"
                                dateFormat="dd/MM/yyyy" 
                                selected={tanggalMulai} 
                                onChange={(e) => setTanggalMulai(e)}
                                />
                        </div>
                        </FormControl>

                        <FormControl pb={6} isRequired fontFamily={'Inter'}>
                        <FormLabel htmlFor='tanggalSelesai'>Tanggal Selesai</FormLabel>
                        <div>
                            <style>
                                {`.date-picker input {
                                    width: 100%;
                                    height: 40px;
                                    padding-left: 17px;
                                    border: 1px solid #E2E8F0;
                                    border-radius: 5px;}
                                .date-picker focus {
                                    border-color:#cd3232;
                                }
                                `}
                            </style>
                            <DatePicker wrapperClassName="date-picker"
                                dateFormat="dd/MM/yyyy" 
                                selected={tanggalSelesai} 
                                onChange={(e) => setTanggalSelesai(e)}
                                />
                        </div>
                        </FormControl>

                        
                        
                        <FormControl pb={6} isRequired fontFamily={'Inter'}>
                        <FormLabel htmlFor='lokasi'>Lokasi</FormLabel>
                        <Input 
                        id='lokasi' 
                        placeholder='Masukkan lokasi' 
                        value={lokasi}
                        onChange={(e) => setLokasi(e.target.value)}/>
                        </FormControl>

                        <FormControl pb={6} isRequired fontFamily={'Inter'}>
                        <FormLabel htmlFor='kuota'>Kuota</FormLabel>
                        <Input 
                        id='kuota' 
                        placeholder='Masukkan kuota peserta magang' 
                        value={kuota}
                        onChange={(e) => setKuota(e.target.value)}/>
                        </FormControl>

                        <FormControl pb={6} isRequired fontFamily={'Inter'}>
                        <FormLabel htmlFor='bayar'>Apakah peserta perlu membayar untuk aktivitas ini?</FormLabel>
                        
                        <Select
                        style={{paddingLeft: "8px", paddingTop: "6px", paddingBottom: "6px", border: '1px solid #F5F5F5', borderRadius: '5px', width: '100%', height:'40px'}} 
                        id='bayar' 
                        onChange={(e) => setBayar(e.target.value)}
                        value={bayar}
                        placeholder="--Pilih--" >
                            <option value="Iya">Iya</option>
                            <option value="Tidak">Tidak</option>
                        </Select>
                        </FormControl>
                        
                        {bayar === "Iya" ? 
                            <div>
                            <FormControl pb={6} isRequired fontFamily={'Inter'}>
                            <FormLabel htmlFor='nominal'>Nominal</FormLabel>
                            <Input 
                            id='nominal' 
                            placeholder='Masukkan nominal' 
                            value={nominal}
                            onChange={(e) => setNominal(e.target.value)}/>
                            </FormControl>
                            <FormControl pb={6} isRequired fontFamily={'Inter'}>
                            <FormLabel htmlFor='batasWaktuPembayaran'>Batas Waktu Pembayaran</FormLabel>
                            <div>
                                <style>
                                    {`.date-picker input {
                                        width: 100%;
                                        height: 40px;
                                        padding-left: 17px;
                                        border: 1px solid #E2E8F0;
                                        border-radius: 5px;}
                                    .date-picker focus {
                                        border-color:#cd3232;
                                    }
                                    `}
                                </style>
                                <DatePicker wrapperClassName="date-picker"
                                    dateFormat="dd/MM/yyyy" 
                                    selected={batasWaktuPembayaran} 
                                    onChange={(e) => setBatasWaktuPembayaran(e)}
                                    />
                            </div>
                            </FormControl>
                            </div>
                        : 
                            <FormControl pb={6} isRequired fontFamily={'Inter'}>
                            <FormLabel htmlFor='nominal'>Nominal</FormLabel>
                            <Input 
                            isDisabled
                            id='nominal' 
                            placeholder='Magang tidak berbayar' 
                            value={null}
                            onChange={(e) => setNominal(null)}/>
                            </FormControl>
                        }

                        <FormControl pb={6}  fontFamily={'Inter'}>
                        <FormLabel htmlFor='deskripsiAktivitas'>Deskripsi Aktivitas</FormLabel>
                        <Textarea 
                        type='text'
                        id='deskripsiAktivitas' 
                        placeholder='Masukkan deskripsi aktivitas' 
                        value={deskripsiAktivitas}
                        onChange={(e) => setDeskripsiAktivitas(e.target.value)}/>
                        </FormControl>

                        <Heading
                        mb={6}
                        mt={3}
                        color={useColorModeValue('gray.700', 'white')}
                        fontSize={'xl'}
                        fontFamily={'Inter'}>
                        Posisi yang dibutuhkan
                        </Heading>

                        <FormControl pb={6} isRequired fontFamily={'Inter'}>
                        <FormLabel htmlFor='namaPosisi'>Nama posisi</FormLabel>
                        <Input 
                        id='namaPosisi' 
                        placeholder='Masukkan nama posisi' 
                        value={namaPosisi}
                        onChange={(e) => setNamaPosisi(e.target.value)}/>
                        </FormControl>

                        <FormControl pb={6} isRequired fontFamily={'Inter'}>
                        <FormLabel htmlFor='deskripsiPekerjaan'>Deskripsi Pekerjaan</FormLabel>
                        <Textarea 
                        type='text'
                        id='deskripsiPekerjaan' 
                        placeholder='Requirements, Kualifikasi peserta, Skills wajib' 
                        value={deskripsiPekerjaan}
                        onChange={(e) => setDeskripsiPekerjaan(e.target.value)}/>
                        </FormControl>

                        <FormControl pb={6} isRequired fontFamily={'Inter'}>
                        <FormLabel htmlFor='kriteriaPeserta'>Kriteria Peserta</FormLabel>
                        <Textarea 
                        type='text'
                        id='kriteriaPeserta' 
                        placeholder='Masukkan kriteria peserta yang diinginkan' 
                        value={kriteriaPeserta}
                        onChange={(e) => setKriteriaPeserta(e.target.value)}/>
                        </FormControl>

                        <FormControl pb={6} isRequired fontFamily={'Inter'}>
                        <FormLabel htmlFor='kemampuanWajib'>Kemampuan Wajib</FormLabel>
                        <Textarea 
                        type='text'
                        id='kemampuanWajib' 
                        placeholder='Masukkan kemampuan wajib yang dibutuhkan' 
                        value={kemampuanWajib}
                        onChange={(e) => setKemampuanWajib(e.target.value)}/>
                        </FormControl>

                        <FormControl pb={6} fontFamily={'Inter'}>
                        <FormLabel htmlFor='infoTambahan'>Info Tambahan</FormLabel>
                        <Textarea 
                        type='text'
                        id='infoTambahan' 
                        placeholder='Info Tambahan' 
                        value={infoTambahan}
                        onChange={(e) => setInfoTambahan(e.target.value)}/>
                        </FormControl>
                        
                        <Stack pt={6} justifyContent='right' direction='row' spacing={4} align='center'>
                            <Button 
                                onClick={() => navigate(-1)}
                                p={6} rounded={'xl'} colorScheme='purple' variant='outline'>
                                Kembali
                            </Button>
                            <Button 
                                type='submit'
                                p={6}
                                colorScheme='purple' 
                                rounded={'xl'}
                                variant='solid'>
                                Kirim
                            </Button>
                        </Stack>
                    </Form>
                </VStack>
            </Box>
        </VStack>
        </Center>
    );
}

export default FormProposal;